<template>
  <div
        class="modal right fade trader-info"
        id="trader-info"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"       
      >
        <div class="modal-dialog modal-dialog-centered modal-md" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" >Change Trader</h5>
              <div class="float-right">
                <button type="button" class="close"  @click="$emit('close')">
                  <span aria-hidden="true">&times;</span>
                </button>
                
              </div>
            </div>
            <div class="modal-body">
              <div class="form-group col-md-12">
                <label for="inputEmail4">
                    TRADER
                </label>
                <multiselect 
                    v-model="selectedTrader" 
                    placeholder="Select trader" 
                    label="firstName" 
                    track-by="cognitoSub"
                    :options="traderList"  
                    :limit="3"  ></multiselect>
            </div>
            <br>
            <div class="modal-footer">
                  <button class="btn btn-light" type="button" @click="$emit('close')">Cancel</button>
                  <button :disabled="!selectedTrader" class="btn btn-success" type="button" @click="updateTrader()">SAVE</button>
                </div>
            </div>
            <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>

          </div>
        </div>
  </div>
</template>

<script>
    import authService from "@/authService";
    import config from "@/config";
    export default {
        name: 'offerchnagetradermodal',
        components :{
            
        },
        props: ['offerData'],
        data() {
            return {
                loading : false,
                traderList : [],
                selectedTrader : null,
            };
        },
        methods: {
            updateTrader(){
                const auth = {
                headers: {'org-token' : authService.getOrgToken() }
                };
                this.$http
                .put(
                    config.baseUrlBidSide + '/offer/update-trader',
                    {"offeringId":this.offerData.id,"cognitoSub":this.selectedTrader.cognitoSub},
                    auth
                )
                .then(() => {
                this.$alert("Trader changed successfully","","success");
                this.$emit('close');  
                })
            }, 
            getTraderList(){
                this.loading = true;
                const auth = {
                    headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
                };
                this.$http
                    .get(
                    config.baseUrlBidSide +
                        "/user/list?page=1&size=1000&search=&status=ACTIVE&sortColumn=firstName&sortOrder=ASC&group=Drl-Trader",
                        auth
                    )
                    .then(result => {
                    // this.traderList = result.data.content.filter((e) => {return e.traderId != null});
                    result.data.content.forEach(trader =>{
                        trader.firstName =  trader.firstName+" "+trader.lastName;
                    });
                    this.traderList = result.data.content;
                    this.traderList.forEach((trader) => {
                        if(trader.cognitoSub == this.offerData.cognitoSub ) this.selectedTrader = trader;
                    })
                    this.loading = false;
                    })
                    .catch(e => {
                    console.log(e);
                    });
            }, 

        },
        mounted(){
          this.getTraderList();
        }
    };
    </script>